
import CountUp from 'react-countup';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect } from 'react';
export default function TrainingDashboard() {
  useEffect(() => {
        window.scrollTo(0, 0); 
      }, []);
  const data = {
    title: " Digital Literacy Skill",
    
    stats: {
      university: 19,
      tots: 101,
      Achievement:2924,
      Target:5000,
    },
  };
 return (
    <div className="min-h-screen bg-gray-50 px-6 py-8">
     
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">{data.title}</h1>
        <p className="text-gray-600">Unlocking the Power of Digital Literacy Why It Matters More Than Ever</p>
      </div>
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
         <div 
          className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#FE5D26]"
          data-tooltip-id="university-tooltip"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">Training Of Trainers</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.tots} duration={2} />
              </h3> 
            </div>
                  <div className="flex flex-col items-center">
    <div className="bg-[#FFF0E5] p-3 rounded-full">
    <svg className="w-6 h-6 text-[#FF9B45]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
    </svg>
  </div>
  <p className="text-[10px] font-semibold text-orange-600 mt-2">40% Female</p>
  </div>
          </div>
         
           </div>
                 
<div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#E52020]">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">University Involved</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.university} duration={2} />
              </h3>
            </div>
            <div className="bg-[#FFE5E5] p-3 rounded-full">
              <svg className="w-6 h-6 text-[#FE5D26]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            
            </div>
          </div>
        </div>

        {/* Total Placed */}
        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#FFC107]">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">Target</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.Target} duration={2} separator="," />
              </h3>
            </div>
            <div className="bg-[#FFF8E5] p-3 rounded-full">
              <svg className="w-6 h-6 text-[#FFC107]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
          </div>
        </div>
         <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#FF9B45]">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">Achievement</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.Achievement} duration={2} separator="," />
              </h3>
            </div>
            <div className="flex flex-col items-center">
            <div className="bg-[#FFF0E5] p-3 rounded-full">
            <svg className="w-6 h-6 text-[#FF9B45]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
    </svg>
  </div>
  <p className="text-[14px] font-semibold text-orange-600 mt-2">40% Female</p>
 </div>
          </div>
        </div>
        
      </div>
    <div className="mt-6 p-4 bg-gray-50 rounded-lg">
      <p className="text-gray-700 italic">"This insight showcases significant improvements in Digital Literacy Skill from the pre- and post-survey assessments of 1300 trainees. These findings highlight the DLS program’s impact in building practical digital competencies and boosting job market readiness"</p>
    </div>
     
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">

       <div className="bg-white p-6 rounded-xl shadow-md mb-8">
  <h2 className="text-2xl font-semibold text-gray-800 mb-6">DLS Beginner Level Training Impact Overview</h2>
  
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
   
    <div className="bg-[#FFF0E5] p-4 rounded-lg border-l-4 border-[#FE5D26]">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">Basic Computer Skills</p>
          <h3 className="text-xl font-bold text-gray-800 mt-1">43% → 85%</h3>
        </div>
        <div className="bg-white p-2 rounded-full">
        </div>
      </div>
      <p className="text-xs text-gray-500 mt-2">Confident in computer use & internet</p>
    </div>

    <div className="bg-[#E5F9FF] p-4 rounded-lg border-l-4 border-[#00A3D9]">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">Digital Applications</p>
          <h3 className="text-xl font-bold text-gray-800 mt-1">32.3% → 88.7%</h3>
        </div>
       
      </div>
      <p className="text-xs text-gray-500 mt-2">Skilled in digital job applications</p>
    </div>

    <div className="bg-[#FFE5F2] p-4 rounded-lg border-l-4 border-[#E8368F]">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">Excel Proficiency</p>
          <h3 className="text-xl font-bold text-gray-800 mt-1">32% → 87%</h3>
        </div>
        
      </div>
      <p className="text-xs text-gray-500 mt-2">Managing tabular data in Excel</p>
     </div>

    <div className="bg-[#E5FFED] p-4 rounded-lg border-l-4 border-[#00C853]">
      <div className="flex items-center justify-between">
        <div className="">
          <p className="text-sm font-medium text-gray-600">Online Platforms</p>
          <h3 className="text-xl font-bold text-gray-800 mt-1">36.3% → 96.9%</h3>
        </div>
        
      </div>
      <p className="text-xs text-gray-500 mt-2">Job applications through online platforms</p>
    </div>
  </div>
  </div> 
  <div className="bg-white p-6 rounded-xl shadow-md mb-8">

  <h2 className="text-2xl font-semibold text-gray-800 mb-6">DLS Intermediate Level Training Impact Overview</h2>
  
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
   
    <div className="bg-[#FFF0E5] p-4 rounded-lg border-l-4 border-[#FE5D26]">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">Hardware & Troubleshooting</p>
          <h3 className="text-xl font-bold text-gray-800 mt-1">5% → 83%</h3>
        </div>
        <div className="bg-white p-2 rounded-full">
        </div>
      </div>
      <p className="text-xs text-gray-500 mt-2">Safe hardware use and troubleshooting</p>
    </div>

    <div className="bg-[#E5F9FF] p-4 rounded-lg border-l-4 border-[#00A3D9]">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">Document Formats</p>
          <h3 className="text-xl font-bold text-gray-800 mt-1">12% → 84.5%</h3>
        </div>
       
      </div>
      <p className="text-xs text-gray-500 mt-2">Professional document recognition</p>
    </div>

    <div className="bg-[#FFE5F2] p-4 rounded-lg border-l-4 border-[#E8368F]">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">Excel Data Management</p>
          <h3 className="text-xl font-bold text-gray-800 mt-1">32% → 87%</h3>
        </div>
        
      </div>
      <p className="text-xs text-gray-500 mt-2">Managing tabular data in Excel</p>
     </div>

    <div className="bg-[#E5FFED] p-4 rounded-lg border-l-4 border-[#00C853]">
      <div className="flex items-center justify-between">
        <div className="">
          <p className="text-sm font-medium text-gray-600">Data Validation</p>
          <h3 className="text-xl font-bold text-gray-800 mt-1">7% → 79.3%</h3>
        </div>
        
      </div>
      <p className="text-xs text-gray-500 mt-2">Spreadsheet data cleaning</p>
    </div>
  </div>
  </div>
 
</div>
      <div className="mt-6">
  <h4 className="text-md font-semibold text-gray-700 mb-2">Highlights from the Program</h4>
  <Slider
    dots={false}
    infinite={true}
    speed={500}
    slidesToShow={3}
    slidesToScroll={1}
    autoplay={true}
    autoplaySpeed={3000}
    arrows={false}
    className="mx-4"
  >
    {[
      "/assets/daap4.jpg",
      "/assets/daap1.jpg",
      "/assets/daap3.jpg",
      "/assets/daap4.jpg",
    ].map((src, index) => (
      <div key={index} className="px-2">
        <img
          src={src}
          alt={`Slide ${index + 1}`}
          className="rounded-lg shadow-md h-40 w-full object-cover"
        />
      </div>
    ))}
  </Slider>
</div>
    </div>
  );
}